module.exports = __webpack_public_path__ + "static/st_logo-8970eea2a585c737017f47dec5f2fc77.png";